import AdminLiveAndUpcomingEventsList from "./liveAndUpcomingEvents";

export default AdminLiveAndUpcomingEventsList;
